import { SupportedLocales } from "@app/shared/utils/locales";
import { FlexCol } from "@design-system/Layout/Flex";
import { Modal } from "@design-system/Modal";
import { Text } from "@design-system/Typography/Text";
import { useState, type FC } from "react";
import LocaleChipSelect from "../../externalQuestionnaire/components/OverviewTab/components/QuestionModal/LocaleChipSelect";
import { useGenerateReportModalTranslations } from "./i18n";

export const GenerateReportModal: FC<{
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: (selectedLocale: SupportedLocales) => void;
}> = ({ open, onOpenChange, onConfirm }) => {
    const { t, keys } = useGenerateReportModalTranslations();

    const handleConfirm = (selectedLocale: SupportedLocales) => {
        return () => onConfirm(selectedLocale);
    };

    const [selectedLocale, setSelectedLocale] = useState<SupportedLocales>(
        SupportedLocales.EN,
    );

    return (
        <Modal open={open} onOpenChange={onOpenChange}>
            <Modal.Overlay centerContent>
                <Modal.Content>
                    <Modal.Header>
                        <Modal.Title>
                            {t(keys.generate_report_modal_title)}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FlexCol gap="2">
                            <Text variant="body" color="primary">
                                {t(keys.generate_report_modal_description)}
                            </Text>
                            <Text variant="body" color="primary">
                                {t(keys.generate_report_modal_locale_label)}
                            </Text>
                            <LocaleChipSelect
                                locale={selectedLocale}
                                setLocale={setSelectedLocale}
                                availableLocales={Object.values(
                                    SupportedLocales,
                                )}
                            />
                        </FlexCol>
                    </Modal.Body>
                    <Modal.Footer>
                        <Modal.CancelCTA>
                            {t(keys.generate_report_modal_cancel_button_label)}
                        </Modal.CancelCTA>
                        <Modal.ConfirmCTA
                            onClick={handleConfirm(selectedLocale)}
                        >
                            {t(keys.generate_report_modal_confirm_button_label)}
                        </Modal.ConfirmCTA>
                    </Modal.Footer>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};
